// @flow
import React, {useState, useEffect} from "react";
import Routes from "./routes/Routes";

// setup fake backend
import { configureFakeBackend } from "./helpers";
import { useHistory, Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

// Import Utils
import utils from "./helpers/utils";

// Themes
//mport { Link, Redirect } from "react-router-dom";
// For Saas import Saas.scss
// import './assets/scss/Saas.scss';
// For Dark import Saas-Dark.scss
// import './assets/scss/Saas-Dark.scss';

// For Modern demo import Modern.scss
// import './assets/scss/Modern.scss';
// For Modern dark demo import Modern-Dark.scss
// import './assets/scss/Modern-Dark.scss';

// For Creative demo import Creative.scss
import "./assets/scss/Creative.scss";
import {MY_ACCOUNT_TITLE} from "./constants/themedata";
import {APICore} from "./helpers/api/apiCore";
import ReactGA from 'react-ga';

const api = new APICore();

// For Creative dark demo import Creative-Dark.scss
// import './assets/scss/Creative-Dark.scss';

// configure fake backend
//configureFakeBackend();

type AppProps = {};

/**
 * Main app component
 */



const App = (props: AppProps): React$Element<any> => {
  const [darkTheme, setDarkTheme] = useState(true);
  const { loadingState, errorIs, accounDatat } = useSelector((state) => ({
    loadingState: state.Auth.loading,
    accounDatat: state.Auth.account,
    errorIs: state.Auth.accounError,

  }));


  useEffect(() => {

   // ReactGA.initialize('G-C5QM9ZM45B');
  }, []);


  

  // Apply Color Scheme
  useEffect(() => {

    let account = api.getAccount();
    if (account && account?.accent_color) {
     // document.title = ` ${MY_ACCOUNT_TITLE}- ${account.business_name}`;
      utils.changeTheme(account.accent_color);
    }else
    if(account && account?.brand_color){

      utils.changeTheme(account?.partner?.brand_color);
    }

    if(account && account?.partner?.id){
      if(account?.partner?.brand_icon){
      utils.changeFavIcon(account?.partner?.brand_icon)
      }else 
      if(account?.partner?.brand_logo){
        utils.changeFavIcon(account?.partner?.brand_logo)
    }
  }else{
    utils.setDefaultFavIcon()
  }
 
  }, [accounDatat]);



  


  //let history = useHistory();
  // React useEffect hook that will fire up
  // when "darkTheme" changes
  // useEffect(() => {
  //     // Accessing scss variable "--background-color"
  //     // and "--text-color" using plain JavaScript
  //     // and changing the same according to the state of "darkTheme"
  //     const root = document.documentElement;
  //     console.log  ( "printing"+ root.style);
  //     if(darkTheme) {
  //   root?.style.setProperty(
  //     "primary",
  //     darkTheme ? "#147833" : "#143833"
  //     );
  //    // root?.style.setProperty("text-color", darkTheme ? "#fff" : "#262833");
  // }
  // }, [darkTheme]);

  return <Routes>

  </Routes>;
};

export default App;
